import { useMemo } from 'react';
import { createAuthenticatedApiClient } from '../../../../shared/api/apiClient';
import { rpcCall } from '../../../../shared/api/rpcClient';
import { useAuth } from '../../../auth/context/AuthContext';
import type {
  GetVersionParametersResponse,
  SetVersionBindingsResponse,
  ListResolversResponse,
  CfnParameterBinding,
} from '../types';

export const createBindingService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    getVersionParameters: (service: string, productName: string, versionName: string): Promise<GetVersionParametersResponse> =>
      rpcCall(client, 'service_components.GetVersionParameters', { service, product_name: productName, version_name: versionName }),

    setVersionBindings: (
      service: string,
      productName: string,
      versionName: string,
      bindings: Record<string, CfnParameterBinding>,
    ): Promise<SetVersionBindingsResponse> =>
      rpcCall(client, 'service_components.SetVersionBindings', { service, product_name: productName, version_name: versionName, bindings }),

    listResolvers: (query?: string): Promise<ListResolversResponse> =>
      rpcCall(client, 'service_components.ListResolvers', query ? { query } : undefined),
  };
};

export const useBindingService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) throw new Error('useBindingService requires authentication');
    return createBindingService(idToken);
  }, [idToken]);
};
